module.exports = __webpack_public_path__ + "static/media/Elizabeth Jenkins Headshot.0cf3729c.jpeg";